import { createSingleEntityStore } from '@core/ngrx-legacy';
import type { CareersSettings } from '@recruitee/careers-site-types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<CareersSettings>()('CareersSiteEntity');

export {
  actions as CareersSiteEntityActions,
  selectors as CareersSiteEntitySelectors,
  reducer as CareersSiteEntityReducer,
  namespace as CareersSiteEntityNamespace,
};
